import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const DEMO_KEY = "handoff_demo";
const HELPER_KEY = "handoff_helper";
let currentMode = null;

const read = (k) => {
  try {
    return JSON.parse(localStorage.getItem(k));
  } catch {
    return null;
  }
};

export const store = {
  getDemo: () => read(DEMO_KEY),
  setDemo: (v) => localStorage.setItem(DEMO_KEY, JSON.stringify(v)),
  clearDemo: () => localStorage.removeItem(DEMO_KEY),
  getHelper: () => read(HELPER_KEY),
  setHelper: (v) => localStorage.setItem(HELPER_KEY, JSON.stringify(v)),
  clearHelper: () => localStorage.removeItem(HELPER_KEY),
};

export const setApiMode = (m) => {
  currentMode = m;
};

export function authHeaders() {
  const h = {};
  const d = store.getDemo();
  const t = store.getHelper();
  if (currentMode === "demo" && d) h["X-Demo-Token"] = d.demo_token;
  if (currentMode === "helper" && t) h["X-Helper-Token"] = t.helper_token;
  return h;
}

export const api = axios.create({ baseURL: API, withCredentials: true });
api.interceptors.request.use((c) => {
  Object.assign(c.headers, authHeaders());
  return c;
});

export const errMsg = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : e?.message && !e?.response ? e.message : fallback;
};

export async function streamPost(path, body, onDelta) {
  const res = await fetch(API + path, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json", ...authHeaders() },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    let d;
    try {
      d = (await res.json()).detail;
    } catch {
      d = null;
    }
    throw new Error(typeof d === "string" ? d : "The writing helper had a hiccup. Please try again.");
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) return;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      const line = p.replace(/^data: /, "").trim();
      if (!line) continue;
      if (line === "[DONE]") return;
      const j = JSON.parse(line);
      if (j.error) throw new Error(j.error);
      onDelta(j.delta);
    }
  }
}

export const fmtDate = (v) => {
  if (!v) return "";
  const d = v.length === 10 ? new Date(`${v}T12:00:00`) : new Date(v);
  return d.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
};

export const fmtTime = (hhmm) => {
  if (!hhmm) return "";
  const [h, m] = hhmm.split(":").map(Number);
  return new Date(2000, 0, 1, h, m).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
};

export const fmtClock = (iso) =>
  iso ? new Date(iso).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" }) : "";

export const money = (n) => `$${Math.round(n).toLocaleString()}`;

export const firstName = (n) => (n || "").split(" ")[0];
